import { Link } from 'react-router-dom';

import routesPath from '@/shared/constants/routesPath';
import { cn } from '@/shared/utils';

import appStoreIcon from '@/assets/app-store.svg';
import googlePlayIcon from '@/assets/google-play.svg';
import Button from '@/components/ui/button';

const LANETALK_SUBSCRIPTIONS_URL = 'https://lanetalk.com/bowlers/';

export default function RestrictedAccess() {
  return (
    <section className="w-full flex justify-center items-center min-h-[calc(100vh-400px)]">
      <div
        className={cn(
          'flex flex-col gap-6 items-center justify-center',
          'px-4 py-4 max-w-[496px]'
        )}
      >
        <h2 className="text-2xl font-bold text-white text-center">
          Want to see live scores?
        </h2>

        <div className="text-secondary text-base text-center space-y-4">
          <p>
            This center is live, but livescoring is only available to LaneTalk
            Pro users at this location.
          </p>
          <p>
            To access the scores, you can either ask the center to activate
            LiveScoring for everyone, or upgrade to Pro in the LaneTalk app.
          </p>
        </div>

        <Button variant="primary" size="lg" asChild>
          <a
            href={LANETALK_SUBSCRIPTIONS_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Upgrade in the app
          </a>
        </Button>

        <div
          className={cn(
            'flex items-center justify-center gap-6',
            'w-full max-w-[302px]'
          )}
        >
          <a
            href="https://apps.apple.com/us/app/lanetalk-bowling/id493763132"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform hover:scale-105"
          >
            <img
              src={appStoreIcon}
              alt="Download on the App Store"
              className="h-10"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.lanetalk"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform hover:scale-105"
          >
            <img
              src={googlePlayIcon}
              alt="Get it on Google Play"
              className="h-10"
            />
          </a>
        </div>

        <p className="text-secondary text-base text-center">
          Already a Pro subscriber?{' '}
          <Link
            to={routesPath.LOGIN}
            className="text-primary underline decoration-2 underline-offset-4 hover:text-light transition-colors"
          >
            Login
          </Link>{' '}
          to watch live scores.
        </p>
      </div>
    </section>
  );
}
